import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-hint-card',
  templateUrl: './hint-card.component.html',
  styleUrls: ['./hint-card.component.scss']
})
export class HintCardComponent {
  @Input() type: 'info' | 'warning' | 'danger' = 'info';
  @Input() outlined = false;
  @Input() set constrainToPage(value: boolean) {
    this.isPageHint = value;
  }
  @HostBinding('class.page-hint') isPageHint = false;

  get cardClasses(): string {
    return `hint-card hint-card--${this.type} ${this.outlined !== false ? 'hint-card--outlined' : ''}`;
  }

  get iconName(): string {
    switch (this.type) {
      case 'info':
        return 'info_outline';
      case 'warning':
        return 'warning_outline';
      case 'danger':
        return 'error_outline';
    }
  }
}
